const downloadBlob = (fileName) => (blob) => {
  // Create a link to download the video
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  const ext = fileName.endsWith(".gif") ? ".gif" : ".mp4";
  a.download = `${fileName}${ext}`;
  document.body.appendChild(a);
  a.click();

  // Clean up
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

const getS3Video = async (url) => {
  const response = await fetch(url);

  console.log(response);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const blob = await response.blob();
  return blob;
};

const downloadS3Video = async (url, fileName) => {
  const blob = await getS3Video(url);
  console.log(blob);
  downloadBlob(fileName)(blob);
};

export const exportKeyMoments = async (activityId, contentId) => {
  // show modal
  const modal = document.getElementById("export-key-moments-modal");
  const modalCloseBtn = document.getElementsByClassName("modal-close-btn");
  const loading = document.getElementById("export-key-moments-loading");
  const results = document.getElementById("export-key-moments-results");

  Array.from(modalCloseBtn).forEach((el) =>
    el.addEventListener("click", () => {
      modal.style.display = "none";
      loading.style.display = "block";
      results.style.display = "none";
    })
  );

  results.style.display = "none";
  loading.style.display = "block";
  modal.style.display = "block";

  const resp = await fetch(`/insights/${activityId}/get_key_moments_videos/${contentId}`, {
    method: "GET",
  })
    .then((r) => r.json())
    .catch((e) => {
      // TODO improve error message
      results.innerHTML = `There was an issue exporting the key moments: ${e}`;
      return false;
    });

  loading.style.display = "none";

  if (!resp) return;
  if (!resp.done) {
    results.innerHTML = `There was an issue exporting the key moments`;
    return;
  }

  const renderedCounter = [];
  // set content
  results.innerHTML = resp.urls
    .map(({ url, name }, idx) => {
      const duplicates = resp.urls.filter((el) => el.name === name);
      renderedCounter.push(name);
      let occurance = "";

      if (duplicates.length > 1) {
        const rendered = renderedCounter.filter((el) => el === name).length;
        occurance = ` #${
          duplicates.length - Math.abs(rendered - duplicates.length)
        }`;
      }

      const isGif = name.endsWith(".gif") || url.endsWith(".gif");
      const mediaEl = isGif
        ? `<img style="flex:1;border-radius:10px;width:100%;max-height:400px;" src="${url}" alt="${name}" />`
        : `<video style="flex:1;border-radius:10px;width:100%;max-height:400px;" src="${url}" controls></video>`;

      return `<div class="flex flex-column" style="gap:20px;">
          <div class="flex" style="justify-content:space-between;align-items:center;">
            <p style="text-transform:capitalize;margin:0;">${name}${occurance}</p>
            <button class="btn btn-primary" style="transform:scale(0.8);transform-origin:center right;" onclick="handleVideoClick('${url}','${activityId}-${name}-${idx}',this)">Download</button>
          </div>
          ${mediaEl}
        </div>`;
    })
    .join("");

  results.style.display = "flex";
};

window.handleVideoClick = async (url, name, btn) => {
  btn.innerHTML = "Downloading...";
  await downloadS3Video(url, name);
  btn.innerHTML = "Download";
};
